/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { ConfigENV } from '@/init';
import { AuthService } from './types';
import { OIDCServiceKeycloak } from './keycloak';
import { OIDCServiceGitlab } from './gitlab';

export class OIDCServiceFactory {
  private static instance: AuthService | null = null;

  constructor(private config: ConfigENV['SERVER_CONFIG']['oidc']) {}

  createService(): AuthService {
    if (OIDCServiceFactory.instance) {
      return OIDCServiceFactory.instance;
    }

    const config = this.config;
    if (!config) {
      throw new Error('OIDC configuration is missing');
    }

    OIDCServiceFactory.instance =
      this.config.provider === 'gitlab' ? new OIDCServiceGitlab(config) : new OIDCServiceKeycloak(config);

    return OIDCServiceFactory.instance;
  }
}
